import styled, { StyledComponentPropsWithRef, css } from 'styled-components';

import { COLOURS, getHeadingFont, isFocused, textShimmer } from '@belong/themes';
import Icon, { StyledIcon } from '@belong/ui-components/components/Icon/Icon';
import { ICON_NAMES } from '@belong/types';

export const IconButton = styled.button`
  all: unset;
  cursor: pointer;
  line-height: 1rem;
  padding: 2px;

  & + & {
    margin-left: 2px;
  }

  ${StyledIcon} {
    color: ${COLOURS.BELONG_BLUE};
  }

  &:hover ${StyledIcon} {
    color: ${COLOURS.BELONG_BLUE_LIGHT};
  }

  &:focus {
    ${isFocused()};
  }
`;

type IconButtonProps = StyledComponentPropsWithRef<typeof IconButton>;

export const CloseButton = (props: IconButtonProps) => (
  <IconButton {...props}>
    <Icon size="small" name={ICON_NAMES.Close} />
  </IconButton>
);
CloseButton.displayName = 'CloseButton';

export const MinimizeButton = (props: IconButtonProps) => (
  <IconButton {...props}>
    <Icon size="small" name={ICON_NAMES.Minimize} />
  </IconButton>
);
MinimizeButton.displayName = 'MinimizeButton';

const AddAttachmentButton = (props: IconButtonProps) => (
  <IconButton {...props}>
    <Icon size="small" name={ICON_NAMES.PaperClip} />
  </IconButton>
);
AddAttachmentButton.displayName = 'AddAttachmentButton';

export const SendButton = (props: IconButtonProps) => (
  <IconButton {...props}>
    <Icon size="small" name={ICON_NAMES.PaperPlane} />
  </IconButton>
);
SendButton.displayName = 'SendButton';

const buttonCss = css`
  z-index: 10;
  padding: 0 0.8rem;
  margin: 0.8rem;
`;

export const StyledAddAttachmentButton = styled(AddAttachmentButton)`
  ${buttonCss}
`;

export const StyledSendButton = styled(SendButton)`
  ${buttonCss}
`;

export const ChatTitleBar = styled.div`
  border: 2px solid black;
  padding: 16px 16px 20px 16px;
  display: flex;
  background: ${COLOURS.GREY_700};
`;

export const ChatTitle = styled.h4`
  ${textShimmer}
  ${getHeadingFont('xs', 'medium')}
  flex: 1;
`;
